export default __webpack_public_path__ + "static/cintra-8366b48bc984e5b4b0d8218a7bb18dc6.jpg";